exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import 'https://fonts.googleapis.com/css?family=Kaushan+Script|Source+Sans+Pro';\ninput:-webkit-autofill + .placeholder-label {\n  -webkit-transform: translate3d(5px, -52%, 0);\n  transform: translate3d(5px, -52%, 0);\n}\n.wrapper-1 {\n  width: 100%;\n  height: calc(100vh - 73px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.wrapper-2 {\n  padding :30px;\n  text-align: center;\n}\nh1 {\n  font-size: 4em;\n  color: #65C2FF;\n  margin-bottom: 20px;\n  font-family: 'Kaushan Script', cursive;\n}\n.cdk-overlay-pane{\n  top: 130px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/check-out/check-out.component.css
// module id = ../../../../../src/app/mnt-invoices/check-out/check-out.component.css
// module chunks = common